/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for updating a workshop.
 * @export
 * @interface WorkshopUpdate
 */
export interface WorkshopUpdate {
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    mentor_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    class_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopUpdate
     */
    is_active?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopUpdate
     */
    start_time?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopUpdate
     */
    end_time?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopUpdate
     */
    series_id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopUpdate
     */
    problem_ids?: Array<string> | null;
}

/**
 * Check if a given object implements the WorkshopUpdate interface.
 */
export function instanceOfWorkshopUpdate(value: object): value is WorkshopUpdate {
    return true;
}

export function WorkshopUpdateFromJSON(json: any): WorkshopUpdate {
    return WorkshopUpdateFromJSONTyped(json, false);
}

export function WorkshopUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'mentor_id': json['mentor_id'] == null ? undefined : json['mentor_id'],
        'class_id': json['class_id'] == null ? undefined : json['class_id'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'start_time': json['start_time'] == null ? undefined : (new Date(json['start_time'])),
        'end_time': json['end_time'] == null ? undefined : (new Date(json['end_time'])),
        'series_id': json['series_id'] == null ? undefined : json['series_id'],
        'problem_ids': json['problem_ids'] == null ? undefined : json['problem_ids'],
    };
}

export function WorkshopUpdateToJSON(json: any): WorkshopUpdate {
    return WorkshopUpdateToJSONTyped(json, false);
}

export function WorkshopUpdateToJSONTyped(value?: WorkshopUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'mentor_id': value['mentor_id'],
        'class_id': value['class_id'],
        'is_active': value['is_active'],
        'start_time': value['start_time'] == null ? undefined : ((value['start_time'] as any).toISOString()),
        'end_time': value['end_time'] == null ? undefined : ((value['end_time'] as any).toISOString()),
        'series_id': value['series_id'],
        'problem_ids': value['problem_ids'],
    };
}

